import React, { useState, useEffect } from "react";
import { Button, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, List, ListItem, Box, DialogTitle, Dialog, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import AddMappingForm from "./AddMappingForm";
import axios from "axios";
import { BACKEND_BASE_URL } from "../config";
import EditMappingForm from "./EditMAppingForm";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Mapping = () => {
    const [open, setOpen] = useState(false);
    const [selectedMapping, setSelectedMapping] = useState(null); // Store selected mapping
    const [mappingData, setMappingData] = useState([]);
    const [editOpen, setEditOpen] = useState(false);  // State to open Edit Form
    const [loading, setLoading] = useState(false); // Loading state for uploads
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [rowToDelete, setRowToDelete] = useState(null);


    useEffect(() => {
        fetchMappingData();
    }, []);

    // Open Edit Form and store selected mapping
    const handleEditClick = (mapping) => {
        setSelectedMapping(mapping);
        setEditOpen(true);
    };


    const fetchMappingData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${BACKEND_BASE_URL}/api/mapping-towns/`);
            setMappingData(response.data);
        } catch (error) {
            console.error("Error fetching mapping data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteClick = (row) => {
        setRowToDelete(row);
        setDeleteDialogOpen(true);
    };

    // Close the Delete Confirmation Dialog
    const handleDeleteClose = () => {
        setDeleteDialogOpen(false);
        setRowToDelete(null);
    };

    // Confirm Delete Action
    const confirmDelete = () => {

        handleDelete(rowToDelete); // Trigger the delete function with selected row ID

        handleDeleteClose(); // Close the dialog
    };
    const handleMap = async (row) => {
        try {
            const response = await axios.post(
                `${BACKEND_BASE_URL}/api/mapping-towns/${row.id}/link_associated_towns/`
            );

            toast.success("Town successfully linked!", {
                position: "top-right",
                autoClose: 3000, // 3 seconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });



            // Update the specific row in the mappingData state to set `mapped` to true
            setMappingData(prevData =>
                prevData.map(item =>
                    item.id === row.id ? { ...item, mapped: true } : item
                )
            );
        } catch (error) {
            console.error("Error linking town:", error);

            toast.error("Failed to link town. Please try again.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handleDelete = async (row) => {

        try {
            await axios.delete(`${BACKEND_BASE_URL}/api/mapping-towns/${row.id}/`);
            toast.success("Deleted successfully");

            // Update state to remove the deleted row
            setMappingData(prevData => prevData.filter(item => item.id !== row.id));

        } catch (error) {
            toast.error("Error deleting data.");
            console.error("Error deleting data:", error);
        }
    };


    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="h4" style={{ fontWeight: "bold" }}>BoE Mappings</Typography>
                    <Button variant="contained" style={{ backgroundColor: "#0B194A", color: "white" }} onClick={() => setOpen(true)}>
                        Add New Mapping
                    </Button>
                </Grid>
            </Grid>

            {loading ? (
                <CircularProgress style={{ display: "block", margin: "20px auto" }} />
            ) : (
                <TableContainer
                    style={{
                        marginTop: 20,
                        border: "1px solid #ddd",
                        maxHeight: "70vh",
                        overflowY: "auto",
                        overflowX: "auto", // ADD THIS HERE
                    }}
                >
                    <div>
                        <Table style={{
                            minWidth: 1200,
                            borderCollapse: "collapse",
                        }}>
                            <TableHead style={{ backgroundColor: "#152F8F" }}>
                                <TableRow>
                                    <TableCell style={{ color: "white", fontWeight: "bold", border: "1px solid #ddd" }}>Municipality</TableCell>
                                    <TableCell style={{ color: "white", fontWeight: "bold", border: "1px solid #ddd" }}>Associated Municipalities</TableCell>
                                    <TableCell style={{ color: "white", fontWeight: "bold", border: "1px solid #ddd" }}> Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mappingData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={2} align="center" style={{ border: "1px solid #ddd" }}>
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    mappingData.map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell style={{ border: "1px solid #ddd", fontWeight: "bold" }}>
                                                {row.big_town.municipality_name} ({row.big_town.state}, {row.big_town.county})
                                            </TableCell>

                                            {/* Nested Table for Associated Small Town Details */}
                                            <TableCell style={{ border: "1px solid #ddd" }}>
                                                <Table size="small">
                                                    <TableHead>
                                                        {index === 0 && ( // Only show this header for the first row
                                                            <TableRow>
                                                                <TableCell style={{ fontWeight: "bold" }}>Country</TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }}>State</TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }}>County</TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }}>Municipality</TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }}>Channel URL</TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>{row.small_town[0].country}</TableCell>
                                                            <TableCell>{row.small_town[0].state}</TableCell>
                                                            <TableCell>{row.small_town[0].county}</TableCell>
                                                            <TableCell>{row.small_town[0].municipality_name}</TableCell>
                                                            <TableCell>
                                                                <List>
                                                                    {row.small_town[0].channel_urls.map((url, i) => (
                                                                        <ListItem key={i} style={{ display: "list-item", listStyleType: "disc" }}>
                                                                            <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#007bff" }}>
                                                                                {url}
                                                                            </a>
                                                                        </ListItem>
                                                                    ))}
                                                                </List>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableCell>

                                            {/* Action Buttons */}
                                            <TableCell>
                                                <Box display={"flex"} flexDirection={"column"}>
                                                    <Box display="flex" flexDirection="row" width="100%">
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => handleEditClick(row)}
                                                            style={{
                                                                marginRight: "10px",
                                                                backgroundColor: "#0B194A",
                                                                color: "white",
                                                            }}
                                                        >
                                                            <i style={{ fontSize: "20px" }} className="fa-solid fa-pen-to-square"></i>
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick={() => handleDeleteClick(row)}
                                                            style={{ backgroundColor: "red" }}
                                                        >
                                                            <span className="material-symbols-outlined">delete</span>
                                                        </Button>
                                                    </Box>
                                                    {row.mapped ? <Button
                                                        variant="contained"
                                                        style={{
                                                            marginTop: "10px",
                                                            backgroundColor: "green",
                                                            color: "white"
                                                        }}

                                                    >

                                                        Mapped
                                                    </Button> : <Button
                                                        variant="contained"
                                                        style={{
                                                            marginTop: "10px",
                                                            backgroundColor: "#0B194A",
                                                            color: "white"
                                                        }}
                                                        onClick={() => handleMap(row)}
                                                    >
                                                        Map
                                                    </Button>}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))

                                )}
                            </TableBody>


                        </Table>
                    </div>
                </TableContainer>
            )}

            <AddMappingForm open={open} onClose={() => setOpen(false)} onMappingAdded={fetchMappingData} />

            {/* Edit Mapping Form */}
            {selectedMapping && (
                <EditMappingForm
                    open={editOpen}
                    onClose={() => setEditOpen(false)}
                    onMappingUpdated={fetchMappingData}
                    mappingData={selectedMapping}
                />
            )}


            {/* Delete Confirmation Dialog */}
            <Dialog
                maxWidth="sm"
                open={isDeleteDialogOpen}
                onClose={handleDeleteClose}
                aria-labelledby="delete-confirmation-dialog"
            >
                <DialogTitle id="delete-confirmation-dialog">
                    Confirm Deletion
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This will only delete this Mapping.
                    </DialogContentText>
                    <DialogContentText sx={{ display: "block", marginTop: 1 }}>
                        If you have deleted it once, you cannot add it again.
                    </DialogContentText>
                    <DialogContentText sx={{ marginTop: 1 }}>
                        Are you sure you want to delete this entry? This action cannot be
                        undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteClose} color="primary" autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="secondary">
                        Yes, Delete
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
};

export default Mapping;
